import { http } from '@pendo/http';

export function getSegmentRecommendations (appId, targetId, targetType, audience, baseVisitorsCount) {
    return http
        .post(
            '/api/s/_SID_/orchestrate/smartsegment/',
            {
                appId,
                targetId,
                targetType,
                audience,
                baseVisitorsCount,
            },
            { timeout: 30000 },
        )
        .then((res) => res.data);
}
